export default {
  industryTitle: '展会行业分类',
  concurrentFair: '展会同行业展会',
  filters: {
    keyword: '关键词',
    selectedCondition: '已选条件',
    area: '区域',
    region: '地区',
    city: '城市',
    hotCity: '热门城市',
    domestic: '国内展会',
    domesticExh: '国内展会(含港澳台)',
    international: '国际展会',
    all: '全部',
    more: '更多',
    packUp: '收起',
    dateFormat: 'YYYY年MM月'
  },
  scale: '展会规模',
  heatSort: '热度排序',
  timeSort: '时间排序',
  recommendedExhibition: '推荐展会',
  industryNews: '展会资讯',
  time: '展会时间',
  latestNews: '最新展会动态资讯',
  timeUpdate: '时间更新中...',
  openness: '开展中...',
  distance: '距离',
  day: '天',
  year: '年',
  periods: '届',
  booth: '展位',
  ticket: '门票',
  exhibitor: '会刊',
  hot: '热门',
  recommended: '推荐',
  winnow: '精选',
  visitorViews: '人浏览',
  updating: '努力更新中...',
  postponed: '时间变更',
  cancelled: '取消',
  notNewTime: '时间待定',
  visitorCount: '观众人数',
  daysToOpen: '距离开展还有',
  ongoing: '开展中...',
  nextEditionUpdate: '下届时间更新中...',
  standardBooth: '标准展位',
  bareSpace: '光地展位',
  subscribed: '已订阅',
  subscribe: '订阅',
  recommendedExhibitions1: '为了满足您的需求，我们为您推荐了',
  recommendedExhibitions2: '同期其他展会的信息，希望能对您有所帮助',
  servicePrompt: '如需参展/参观可咨询在线客服',
  contactCustomerService: '咨询客服'
}
